import debug from '../debug';

interface SessionWithTokens {
  tokens: {
    accessToken: {
      payload: {
        'cognito:groups'?: string[];
      };
    };
  };
}

interface SessionWithGroups {
  groups?: string[] | null;
}

type Session = SessionWithTokens | SessionWithGroups;

const isInGroup = (
  session: Session | null | undefined,
  groupName: string,
): boolean => {
  try {
    if (session) {
      const groups =
        'tokens' in session
          ? session.tokens.accessToken.payload['cognito:groups']
          : session.groups;

      if (Array.isArray(groups)) {
        return groups.includes(groupName);
      }
    }
  } catch (err) {
    debug('isInGroup', err);
  }
  return false;
};

export type { Session };
export default isInGroup;
